module.exports = __webpack_public_path__ + "static/jeremy-camp.567d871c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/people/jeremy-camp.jpg
// module id = 1306
// module chunks = 168707334958949